module.exports = __webpack_public_path__ + "static/img/photo_huitan.6153f65.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/photo/photo_huitan.jpg
// module id = 4aMU
// module chunks = 12